"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.digitLength = digitLength;
exports.divide = divide;
exports.float2Fixed = float2Fixed;
exports.rewriteNumberToFixed = rewriteNumberToFixed;
exports.safeToFixed = safeToFixed;
exports.strip = strip;
exports.times = times;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function strip(num) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
  if (isNaN(num)) return NaN;
  return +parseFloat(Number(num).toPrecision(precision));
}
function digitLength(num) {
  if (!isFinite(num)) return 0;
  var eSplit = num.toString().split(/[eE]/);
  var len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
  return len > 0 ? len : 0;
}
function float2Fixed(num) {
  if (num.toString().indexOf('e') === -1) {
    return Number(num.toString().replace('.', ''));
  }
  var dLen = digitLength(num);
  return dLen > 0 ? strip(Number(num) * Math.pow(10, dLen)) : Number(num);
}
function times(num1, num2) {
  var num1Changed = float2Fixed(num1);
  var num2Changed = float2Fixed(num2);
  var baseNum = digitLength(num1) + digitLength(num2);
  var leftValue = num1Changed * num2Changed;
  return leftValue / Math.pow(10, baseNum);
}
function divide(num1, num2) {
  var num1Changed = float2Fixed(num1);
  var num2Changed = float2Fixed(num2);
  return times(num1Changed / num2Changed, strip(Math.pow(10, digitLength(num2) - digitLength(num1))));
}
var originalToFixed = Number.prototype.toFixed;
window.originalToFixed = originalToFixed;
function safeToFixed(num, decimal) {
  try {
    if (isNaN(num) || isNaN(decimal) || typeof decimal !== 'number') {
      return (Number.prototype.originalToFixed || originalToFixed).call(num, decimal);
    }
    var base = Math.pow(10, decimal);
    var result = divide(Math.round(Math.abs(times(num, base))), base);
    if (num < 0 && result !== 0) {
      result = times(result, -1);
    }
    var _result$toString$spli = result.toString().split("."),
      _result$toString$spli2 = _slicedToArray(_result$toString$spli, 2),
      intPart = _result$toString$spli2[0],
      _result$toString$spli3 = _result$toString$spli2[1],
      decimalPart = _result$toString$spli3 === void 0 ? "" : _result$toString$spli3;
    var paddedDecimal = decimalPart.length >= decimal ? decimalPart : decimalPart + '0'.repeat(decimal - decimalPart.length);
    return decimal > 0 ? "".concat(intPart, ".").concat(paddedDecimal) : intPart;
  } catch (e) {
    console.warn("safeToFixed error", {
      num: num,
      decimal: decimal,
      error: e
    });
    return (Number.prototype.originalToFixed || originalToFixed).call(num, decimal);
  }
}
function rewriteNumberToFixed() {
  if (!Number.prototype.originalToFixed) {
    Number.prototype.originalToFixed = Number.prototype.toFixed;
  }
  Number.prototype.toFixed = function (decimal) {
    return safeToFixed(this.valueOf(), decimal);
  };
}